import React from "react";
import { Link } from "react-router-dom";
import "./Footer.css";

const Footer = () => {
  const PHONE = "+919318333680";
  const WHATSAPP = "919318333680";

  const whatsappMessage = encodeURIComponent(
    "Hi, I need sofa repair / upholstery service from RK Sofa Works."
  );

  const whatsappURL = `https://wa.me/${WHATSAPP}?text=${whatsappMessage}`;

  return (
    <footer className="rk-footer">

      {/* =========================================
          TOP CTA
      ========================================= */}
      <section className="rk-footer-cta">
        <div className="rk-footer-cta-pattern"></div>

        <div className="container">
          <div className="rk-footer-cta-inner">

            <div className="rk-footer-cta-copy">
              <span className="rk-footer-eyebrow">
                RK SOFA WORKS
              </span>

              <h2>
                Give Your Sofa
                <br />
                <em>A Fresh Start.</em>
              </h2>

              <p>
                From simple repairs to complete upholstery
                makeovers, we help bring comfort and character
                back to your furniture.
              </p>
            </div>

            <div className="rk-footer-cta-actions">

              <a
                href={`tel:${PHONE}`}
                className="rk-footer-call"
              >
                <span className="rk-footer-btn-icon">
                  <i className="fa-solid fa-phone"></i>
                </span>

                <span>
                  <small>Speak With Us</small>
                  <strong>Call Now</strong>
                </span>

                <i className="fa-solid fa-arrow-right rk-footer-arrow"></i>
              </a>

              <a
                href={whatsappURL}
                target="_blank"
                rel="noopener noreferrer"
                className="rk-footer-whatsapp"
              >
                <span className="rk-footer-btn-icon">
                  <i className="fa-brands fa-whatsapp"></i>
                </span>

                <span>
                  <small>Quick Enquiry</small>
                  <strong>WhatsApp Us</strong>
                </span>

                <i className="fa-solid fa-arrow-right rk-footer-arrow"></i>
              </a>

            </div>
          </div>
        </div>
      </section>


      {/* =========================================
          MAIN FOOTER
      ========================================= */}
      <section className="rk-footer-main">

        <div className="container">

          <div className="row g-4">

            {/* BRAND COLUMN */}
            <div className="col-lg-4 col-md-6">

              <div className="rk-footer-brand">

                <Link
                  to="/"
                  className="rk-footer-logo"
                  aria-label="RK Sofa Works Home"
                >
                  <img
                    src={`${process.env.PUBLIC_URL}/img/logo.png`}
                    alt="RK Sofa Works"
                  />
                </Link>

                <div className="rk-footer-brand-line">
                  <span></span>
                  <small>CRAFT • COMFORT • CARE</small>
                </div>

                <p>
                  RK Sofa Works provides sofa repair,
                  re-upholstery, cushion restoration and
                  custom sofa solutions for homes and
                  businesses across Delhi NCR.
                </p>

                <div className="rk-footer-social">

                  <a
                    href={whatsappURL}
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="RK Sofa Works WhatsApp"
                  >
                    <i className="fa-brands fa-whatsapp"></i>
                  </a>

                  <a
                    href={`tel:${PHONE}`}
                    aria-label="Call RK Sofa Works"
                  >
                    <i className="fa-solid fa-phone"></i>
                  </a>

                  <a
                    href="mailto:rksofaworks@gmail.com"
                    aria-label="Email RK Sofa Works"
                  >
                    <i className="fa-solid fa-envelope"></i>
                  </a>

                </div>

              </div>

            </div>


            {/* QUICK LINKS */}
            <div className="col-lg-2 col-md-6">

              <div className="rk-footer-column">

                <span className="rk-footer-column-number">
                  
                </span>

                <h3>Explore</h3>

                <ul>
                  <li>
                    <Link to="/">
                      <span>Home</span>
                      <i className="fa-solid fa-arrow-right"></i>
                    </Link>
                  </li>

                  <li>
                    <Link to="/about">
                      <span>About Us</span>
                      <i className="fa-solid fa-arrow-right"></i>
                    </Link>
                  </li>

                  <li>
                    <Link to="/sofa_repair">
                      <span>Our Services</span>
                      <i className="fa-solid fa-arrow-right"></i>
                    </Link>
                  </li>

                  <li>
                    <Link to="/contact_us">
                      <span>Contact</span>
                      <i className="fa-solid fa-arrow-right"></i>
                    </Link>
                  </li>
                </ul>

              </div>

            </div>


            {/* SERVICES */}
            <div className="col-lg-3 col-md-6">

              <div className="rk-footer-column">

                <span className="rk-footer-column-number">
                </span>

                <h3>What We Do</h3>

                <ul>
                  <li>
                    <Link to="/sofa_repair">
                      <span>Sofa Repair</span>
                      <i className="fa-solid fa-arrow-right"></i>
                    </Link>
                  </li>

                  <li>
                    <Link to="/sofa_repair">
                      <span>Re-Upholstery</span>
                      <i className="fa-solid fa-arrow-right"></i>
                    </Link>
                  </li>

                  <li>
                    <Link to="/sofa_repair">
                      <span>Cushion & Foam Work</span>
                      <i className="fa-solid fa-arrow-right"></i>
                    </Link>
                  </li>

                  <li>
                    <Link to="/sofa_repair">
                      <span>Custom Sofa</span>
                      <i className="fa-solid fa-arrow-right"></i>
                    </Link>
                  </li>

                  <li>
                    <Link to="/sofa_repair">
                      <span>Sofa Makeover</span>
                      <i className="fa-solid fa-arrow-right"></i>
                    </Link>
                  </li>
                </ul>

              </div>

            </div>


            {/* CONTACT */}
            <div className="col-lg-3 col-md-6">

              <div className="rk-footer-column rk-footer-contact">

                <span className="rk-footer-column-number">
                
                </span>

                <h3>Get In Touch</h3>

                <div className="rk-contact-card">

                  <div className="rk-contact-icon">
                    <i className="fa-solid fa-phone"></i>
                  </div>

                  <div>
                    <small>Call Us</small>
                    <a href={`tel:${PHONE}`}>
                      +91 93183 33680
                    </a>
                  </div>

                </div>


                <div className="rk-contact-card">

                  <div className="rk-contact-icon">
                    <i className="fa-solid fa-envelope"></i>
                  </div>

                  <div>
                    <small>Email</small>
                    <a href="mailto:rksofaworks@gmail.com">
                      rksofaworks@gmail.com
                    </a>
                  </div>

                </div>


                <div className="rk-contact-card">

                  <div className="rk-contact-icon">
                    <i className="fa-solid fa-location-dot"></i>
                  </div>

                  <div>
                    <small>Service Area</small>
                    <span>
                      Noida &amp; Delhi NCR
                    </span>
                  </div>

                </div>

              </div>

            </div>

          </div>


          {/* SERVICE AREAS STRIP */}
          <div className="rk-footer-area-strip">

            <div className="rk-area-title">
              <span>WE SERVE</span>
              <strong>Delhi NCR</strong>
            </div>

            <div className="rk-area-list">
              <span>Noida</span>
              <span>Greater Noida</span>
              <span>Ghaziabad</span>
              <span>Delhi</span>
              <span>Faridabad</span>
              <span>Gurugram</span>
              <span>Indirapuram</span>
              <span>Vaishali</span>
            </div>

          </div>

        </div>

      </section>


      {/* =========================================
          BOTTOM BAR
      ========================================= */}
      <div className="rk-footer-bottom">

        <div className="container">

          <div className="rk-footer-bottom-inner">

            <p>
              © {new Date().getFullYear()}{" "}
              <strong>RK Sofa Works</strong>.
              All rights reserved.
            </p>

            <div className="rk-footer-bottom-links">
              <span>Repair</span>
              <span>Restore</span>
              <span>Refresh</span>
            </div>

          </div>

        </div>

      </div>

    </footer>
  );
};

export default Footer;